import { render, staticRenderFns } from "./PlayerWinloseSimple.vue?vue&type=template&id=0d716188&"
import script from "./PlayerWinloseSimple.vue?vue&type=script&lang=js&"
export * from "./PlayerWinloseSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports